import React from 'react'

import { FormSubmitErrorsProps } from '../../form/FormSubmitErrors'
import { TextFieldProps } from '../../form/TextField'
import FormikField from '../../form/FormikField'
import { SubmitButtonProps } from '../../form/SubmitButton'
import { FormikFormProps } from '../../form/FormikForm'

import * as SC from './styled'

export type ResetPasswordFormValues = {
  password: string
  passwordConfirmation: string
}

export type ResetPasswordFormProps = {
  className?: string
  formik: FormikFormProps<ResetPasswordFormValues>
  text?: string
  fields: {
    password: TextFieldProps
    passwordConfirmation: TextFieldProps
  }
  submitErrors?: FormSubmitErrorsProps['errors']
  submitButton: SubmitButtonProps
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  className,
  text,
  formik,
  fields,
  submitErrors,
  submitButton,
}) => {
  return (
    <SC.Form {...formik} className={className}>
      <SC.Text dangerouslySetInnerHTML={{ __html: text ?? '' }}></SC.Text>
      <FormikField {...fields.password} Component={SC.TextField} type="password" />
      <FormikField {...fields.passwordConfirmation} Component={SC.TextField} type="password" />
      {submitErrors && <SC.SubmitErrors errors={submitErrors} />}
      <SC.Submit {...submitButton} />
    </SC.Form>
  )
}

export default ResetPasswordForm
